export interface SupportTicket {
  id: string;
  type: string;
  date: string;
  status: "solved" | "review" | "open";
  statusLabel: string;
}

export const tickets: SupportTicket[] = [
  { id: "TK-1245", type: "تسوية مالية", date: "14 أغسطس", status: "solved", statusLabel: "محلولة ✓" },
  { id: "TK-1250", type: "فني", date: "16 أغسطس", status: "review", statusLabel: "قيد المراجعة" },
  { id: "TK-1252", type: "بنر إعلاني", date: "17 أغسطس", status: "open", statusLabel: "مفتوحة" },
];

export const issueTypes = [
  "طلب",
  "تسوية مالية",
  "حساب",
  "فني",
  "بنر أو رفع ظهور",
  "أخرى",
];

export interface TicketMessage {
  id: number;
  author: "provider" | "admin";
  authorName: string;
  time: string;
  text: string;
}

export interface TicketTimelineEvent {
  id: number;
  label: string;
  time: string;
  done: boolean;
}

export interface TicketAttachment {
  name: string;
  size: string;
}

export interface TicketDetail {
  id: string;
  subject: string;
  conversation: TicketMessage[];
  timeline: TicketTimelineEvent[];
  attachments: TicketAttachment[];
  resolutionNote?: string;
}

export const ticketDetails: Record<string, TicketDetail> = {
  "TK-1245": {
    id: "TK-1245",
    subject: "استفسار عن غرامة تسوية شهر يوليو",
    conversation: [
      {
        id: 1,
        author: "provider",
        authorName: "أحمد محمد",
        time: "14 أغسطس، 10:24",
        text: "السلام عليكم، عندي استفسار بخصوص تسوية شهر يوليو — لاحظت خصم غرامة 100 ر.س على الطلب GH-2743 وأنا التأخير كان خارج إرادتي.",
      },
      {
        id: 2,
        author: "admin",
        authorName: "فريق الإدارة",
        time: "14 أغسطس، 11:02",
        text: "وعليكم السلام، راجعنا الطلب GH-2743. الغرامة كانت بسبب تأخر وصول الفريق 45 دقيقة عن الموعد المحدد.",
      },
      {
        id: 3,
        author: "provider",
        authorName: "أحمد محمد",
        time: "14 أغسطس، 11:40",
        text: "التأخير كان بسبب عطل مفاجئ في سيارة الفريق، ورفعت لكم إثبات ورشة الصيانة بالمرفق.",
      },
      {
        id: 4,
        author: "admin",
        authorName: "فريق الإدارة",
        time: "15 أغسطس، 09:15",
        text: "تم التحقق من المستند المرفق، وسيتم إلغاء الغرامة وإعادة احتساب صافي التسوية.",
      },
      {
        id: 5,
        author: "admin",
        authorName: "فريق الإدارة",
        time: "15 أغسطس، 14:30",
        text: "تم تحديث التسوية — الصافي الجديد 3,230 ر.س وسيتم التحويل خلال الدورة القادمة. شكراً لصبرك.",
      },
    ],
    timeline: [
      { id: 1, label: "فتح التذكرة", time: "14 أغسطس", done: true },
      { id: 2, label: "قيد المراجعة", time: "14 أغسطس", done: true },
      { id: 3, label: "محلولة", time: "15 أغسطس", done: true },
    ],
    attachments: [{ name: "إثبات-الورشة.pdf", size: "240 KB" }],
    resolutionNote:
      "تم إلغاء غرامة 100 ر.س بعد التحقق من إثبات عطل سيارة الفريق، وأعيد احتساب صافي التسوية إلى 3,230 ر.س.",
  },
  "TK-1250": {
    id: "TK-1250",
    subject: "الطلبات الجديدة لا تظهر في لوحة التحكم",
    conversation: [
      {
        id: 1,
        author: "provider",
        authorName: "أحمد محمد",
        time: "16 أغسطس، 08:50",
        text: "منذ يومين التطبيق ما يعرض لي طلبات جديدة، وبعض التنبيهات ما توصل لي نهائياً.",
      },
      {
        id: 2,
        author: "admin",
        authorName: "فريق الإدارة",
        time: "16 أغسطس، 10:15",
        text: "أهلين، جاري فحص المشكلة مع الفريق الفني. هل تقصد أن الطلبات الجديدة لا تظهر في قائمة الطلبات داخل اللوحة؟",
      },
      {
        id: 3,
        author: "provider",
        authorName: "أحمد محمد",
        time: "16 أغسطس، 10:32",
        text: "بالضبط، الطلبات توصلني عبر البريد الإلكتروني بس ما تظهر في قائمة الطلبات داخل التطبيق.",
      },
    ],
    timeline: [
      { id: 1, label: "فتح التذكرة", time: "16 أغسطس", done: true },
      { id: 2, label: "قيد المراجعة", time: "16 أغسطس", done: true },
    ],
    attachments: [],
  },
  "TK-1252": {
    id: "TK-1252",
    subject: "طلب بنر إعلاني مميز",
    conversation: [
      {
        id: 1,
        author: "provider",
        authorName: "أحمد محمد",
        time: "17 أغسطس، 13:20",
        text: "أرغب في طلب بنر إعلاني مميز لعرض خدماتي خلال الأسبوع القادم، كم التكلفة وطريقة الدفع؟",
      },
      {
        id: 2,
        author: "admin",
        authorName: "فريق الإدارة",
        time: "17 أغسطس، 15:45",
        text: "أهلين، شكراً لاهتمامك. فريق المبيعات بيواصلك خلال 24 ساعة بتفاصيل الباقات والأسعار المتاحة.",
      },
    ],
    timeline: [{ id: 1, label: "فتح التذكرة", time: "17 أغسطس", done: true }],
    attachments: [],
  },
};

export function getTicketDetail(id: string): TicketDetail {
  return (
    ticketDetails[id] ?? {
      id,
      subject: "تذكرة الدعم",
      conversation: [],
      timeline: [{ id: 1, label: "فتح التذكرة", time: "اليوم", done: true }],
      attachments: [],
    }
  );
}